<ng-template #template let-notifyData="data">
  <div class="flex gap-5 items-center">
    <div class="flex justify-center items-center w-8 h-8 rounded-full min-w-8">
      <div
        [ngStyle]="{ 'box-shadow': configData(notifyData.type).boxShadow }"
        class="flex justify-center items-center w-5 h-5 rounded-full text-[#2D4953]"
      >
        <app-svg-icon
          [icon]="configData(notifyData.type).icon"
          class="w-5 h-5"
        />
      </div>
    </div>

    <div class="flex flex-col">
      <span
        class="capitalize mb-1"
        [ngClass]="configData(notifyData.type).titleColor"
        >{{ notifyData.type }}</span
      >
      <span class="text-[#D9DFE9] text-xs max-w-[450px]">{{
        notifyData.message
      }}</span>
    </div>
  </div>
</ng-template>
